module.exports = __webpack_public_path__ + "static/media/home1.1f172b6b.jpg";